<template>
  <section ref="videoSection" class="aboutus-section aboutus-video-section">
    <div class="aboutus-video-wrap" :style="{ backgroundImage: `url(${vedioBg})` }">
      <div class="aboutus-video">
        <video ref="videoRef" controls class="aboutus-video-player">
          <source :src="videoUrl" type="video/mp4">
          {{ t('aboutUs.video.unsupportedMessage') }} 
        </video>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import aboutVedio from '../../assets/aboutUs/vedio.mp4';

const { t } = useI18n();
const videoRef = ref(null);
const videoUrl = ref(aboutVedio);
const vedioBg = ref(t('aboutUs.video.backgroundImage'));
const videoSection = ref(null);
let observer = null;

// 监听组件可见性变化
const handleIntersection = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (videoRef.value) {
        videoRef.value.play().catch((error) => {
          console.error('视频播放失败:', error);
        });
      }
    } else {
      if (videoRef.value) {
        videoRef.value.pause();
      }
    }
  });
};

onMounted(() => {
  // 创建 IntersectionObserver 实例
  observer = new IntersectionObserver(handleIntersection);
  if (videoSection.value) {
    observer.observe(videoSection.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
.aboutus-section {
  width: 100%;
  margin: 0 auto;
  padding: 56px 0 0 0;
  background: #fff;
  margin-top: 10vh;
}

.aboutus-video-section {
  background: #f7f7f7;
  padding: 2vh 0 2vh 0;
  display: flex;
  justify-content: center;
}

.aboutus-video-wrap {
  width: 60%;
  margin: 0 auto;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 16/9;
  position: relative;
  background-size: cover;
  background-position: center;
}

.aboutus-video {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.aboutus-video-play {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

/* 基础按钮尺寸 */
.aboutus-video-play img {
  width: 80px;
  height: 80px;
}

.aboutus-video-player {
  max-width: 100%;
  max-height: 80vh;
  width: auto;
  height: auto;
  margin: 30px;
}

@media screen and (min-width: 1400px) {
  .aboutus-video-play img {
    width: 120px;
    height: 120px;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .aboutus-video-play img {
    width: 100px;  /* 中等屏幕缩小 */
    height: 100px;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .aboutus-video-play img {
    width: 80px;  /* 平板进一步缩小 */
    height: 80px;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .aboutus-video-play img {
    width: 60px;  /* 手机最小尺寸 */
    height: 60px;
  }
}
</style>